import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getDeliveryOptions = (state: TInitialState) => ({
    deliveryOptionsList: state.deliveryOptions,
    selectedDeliveryOption: state.selected.deliveryOption,
});

export default getDeliveryOptions;
